import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { map as _map } from 'lodash';

import HeaderMobile from '../HeaderMobile/HeaderMobile';

import {
  HeaderContainer,
  HeaderInnerContainer,
  LogoContainer,
  LogoLink,
  LogoImage,
  NavigationContainer,
  Navigation,
  NavigationItem,
  NavigationLink,
  SubNavigationContainer,
  SubNavigation,
  SubNavigationItem,
  SubNavigationLink,
  CtaContainer,
  CtaInnerContainer,
  ButtonContainer,
  ApplyButton,
  BookATourButton,
  MobileHeaderContainer,
} from './Header.css.js';

class Header extends Component {
  state = {
    subNavigationItems: []
  }

  renderLogo() {
    return(
      <LogoContainer>
        <LogoLink
          href={`/`}
        >
          <LogoImage
            src={`/images/ce-montessori/logos/ce-montessori-logo-horizontal-white-text.png`}
            alt={`c'e Montessori Logo`}
          />
        </LogoLink>
      </LogoContainer>
    );
  }

  renderSubNavigation(title, subNavigationItems) {
    const itemRow = (subNavigationItems, index) => {
      const renderSubNavItems = (subNavigationItems) => {
        return _map(subNavigationItems, (subNavigationItem, index) => (
            <SubNavigationItem
              key={index}
            >
              <SubNavigationLink href={subNavigationItem.link}>{subNavigationItem.label}</SubNavigationLink>
            </SubNavigationItem>
          )
        );
      };

      return (
        <SubNavigation
          key={index}
        >
          {renderSubNavItems(subNavigationItems)}
        </SubNavigation>
      );
    };

    // lets only render three subnavigation items per row
    const itemRows = (subNavigationItems) => {
      const navigationRows = [];

      for (let i=0; i < subNavigationItems.length; i+=3) {
        const endIndex = i+3 < subNavigationItems.length ? i+3 : subNavigationItems.length;
        const items = subNavigationItems.slice(i, endIndex);

        navigationRows.push(itemRow(items, i));
      }

      return navigationRows;
    };

    return(
      <SubNavigationContainer data-subnavigation={title}>
        {itemRows(subNavigationItems)}
      </SubNavigationContainer>
    );
  }

  renderNavigationItems(navigationItems) {
    return (
      _map(navigationItems, (navigationItem, index) => {
          // if (!!navigationItem.subNavigationItems) {
          //   debugger;
          //   console.log(`>>>>>> TESTING >>>>>>>>>>>>`);
          //   console.log(navigationItem.subNavigationItems);
          // }

          return (
            <NavigationItem
              key={index}
            >
              <NavigationLink href={navigationItem.link}>{navigationItem.label}</NavigationLink>
              {(!!navigationItem.subNavigationItems) ? this.renderSubNavigation(navigationItem.label, navigationItem.subNavigationItems) : null}
            </NavigationItem>
          );
        }
      )
    );
  }

  renderNavigation() {
    const { navigationItems } = this.props.content;

    return (
      <NavigationContainer>
        <Navigation role={`navigation`}>
          {this.renderNavigationItems(navigationItems)}
        </Navigation>
      </NavigationContainer>
    );
  }

  renderCtaContainer() {
    return (
      <CtaContainer>
        <CtaInnerContainer>
          <ButtonContainer>
            <ApplyButton
              href={`/application`}
            >
              Apply Now
            </ApplyButton>

            <BookATourButton
              href={`/tours`}
            >
              Book a Tour
            </BookATourButton>
          </ButtonContainer>
        </CtaInnerContainer>
      </CtaContainer>
    );
  }

  render() {
    const { showLogo } = this.props.config;

    return (
      <React.Fragment>
        <HeaderContainer>
          <HeaderInnerContainer>
            {showLogo ? this.renderLogo() : <span></span>}

            {this.renderNavigation()}

            {this.renderCtaContainer()}
          </HeaderInnerContainer>
        </HeaderContainer>

        <MobileHeaderContainer>
          <HeaderMobile
            config={this.props.config}
            content={this.props.content}
          />
        </MobileHeaderContainer>
      </React.Fragment>
    );
  }
}

Header.propTypes = {
  config: PropTypes.shape({
    showLogo: PropTypes.bool,
  }),
  content: PropTypes.shape({
    navigationItems: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        link: PropTypes.string,
        subNavigationItems: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            link: PropTypes.string,
          }),
        ),
      })
    ).isRequired,
  }),
};

Header.defaultProps = {
  config: {
    showLogo: true,
  },
};

export default Header;